/**
 * @fileoverview
 * Utility function to detect locale from the browser setting, cookie, or parameter on the URL.
 */

import queryString from 'query-string';

// 获取 cookie 值
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
};

/**
 * look for language setting in cookie, browser, or URL parameter.
 * Priority: URL param > cookie > browser language > default 'en'
 * @param {Array.string} supportedLocales An array of supported locale codes.
 * @return {string} the preferred locale
 */
const detectLocale = supportedLocales => {
    // 1. Check cookie first (shared with course-ui)
    const cookieLang = getCookie('language');
    if (cookieLang) {
        // Convert cookie value to locale format
        if (cookieLang === 'zh') return 'zh-cn';
        if (cookieLang === 'en') return 'en';
    }

    // 2. Check browser language
    let locale = 'en'; // default
    let browserLocale = window.navigator.userLanguage || window.navigator.language;
    browserLocale = browserLocale.toLowerCase();
    // Map zh-* to zh-cn
    if (browserLocale.startsWith('zh')) {
        browserLocale = 'zh-cn';
    }
    if (supportedLocales.includes(browserLocale)) {
        locale = browserLocale;
    }

    // 3. Check URL parameter (highest priority)
    const queryParams = queryString.parse(location.search);
    const potentialLocales = [].concat(queryParams.locale, queryParams.lang).filter(l => l);
    if (!potentialLocales.length) {
        return locale;
    }

    const urlLocale = potentialLocales[0].toLowerCase();
    if (supportedLocales.includes(urlLocale)) {
        return urlLocale;
    }

    return locale;
};

export {
    detectLocale
};
